import zhCN from "./zhCN";

export default zhCN;
